import { css } from '@emotion/react';
import { MOBILE_BREAKPOINT } from '../../../submission-details-view.constants';

export const chipStyleOverride = css`
  @container submission-details-view (max-width: ${MOBILE_BREAKPOINT}px) {
    overflow: hidden;
  }
`;
